import React, { useCallback, useMemo } from 'react';

import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { updateLocalStateValues } from 'components/RabbitOKRSidePanel/KRslice';
import useOKRConfig from 'components/hooks/useOKRConfig';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { kRDrawerSelector } from 'selectors/kRDrawer';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { GOAL_MEASUREMENT_TYPES, OKR_PROGRESS_TYPES, OKR_TYPES } from 'constants/ProjectConstants';

import { OKRTrackingTypeSection } from './OKRTrackingTypeSection';

interface Props {
  isEditOKR?: boolean;
}

const Tracking = ({ isEditOKR }: Props) => {
  const { IS_KR_CASCADING_ENABLED } = useOKRConfig();
  const dispatch = useDispatch();
  const createOKRDetails = useSelector(okrCreationPanelStateSelector);
  const editOKRSavedDetails = useSelector(kRDrawerSelector);
  const editOKRDetails = useMemo(
    () => ({ ...editOKRSavedDetails, ...editOKRSavedDetails.localStateValues }),
    [editOKRSavedDetails]
  );
  const okrDetails = isEditOKR ? editOKRDetails : createOKRDetails;
  const {
    type,
    progressType = OKR_PROGRESS_TYPES.MANUAL,
    parentMeasure,
    parentMeasureType,
    parentProgressType,
  } = okrDetails;

  const isObjective = type === OKR_TYPES.OBJECTIVE;
  const disableDependentType = !isObjective && !IS_KR_CASCADING_ENABLED;
  const disableDerivedAvg = parentProgressType === OKR_PROGRESS_TYPES.DERIVED_SUM;

  const onChange = useCallback(
    (updates) => {
      dispatch(isEditOKR ? updateLocalStateValues(updates) : updateOKR(updates));
    },
    [dispatch, isEditOKR]
  );

  return (
    <OKRTrackingTypeSection
      progressType={progressType}
      onChange={(updates) => onChange(updates)}
      isReadOnly={false}
      okrHasNoChildren={false}
      areChildSummable
      disableDependentType={disableDependentType}
      disableDerivedAvg={disableDerivedAvg}
      /* below parentMeasure / parentMeasureType will be used as default when switching to Derived Sum */
      parentMeasure={parentMeasure ?? GOAL_MEASUREMENT_TYPES[0]?.code}
      parentMeasureType={parentMeasureType ?? ''}
      hideTrackingByThirdPartyIntegrations
    />
  );
};

export { Tracking };
